import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// redux
import { getUsers, setNewUserById } from 'redux/users/operations';
import { selectUsersListNew } from 'redux/users/usersSelectors';
// helpers
import { setPageTitle } from 'helpers';
// scss
import './UsersList.scss';

const NewUsersList = () => {
  const [render, setRender] = useState(true);
  const dispatch = useDispatch();
  const usersList = useSelector(selectUsersListNew);

  function onUpdate(user_id, actionType) {
    dispatch(setNewUserById({ user_id, status: actionType }));
  }

  useEffect(() => { setPageTitle("Нові користувачі") }, []);

  useEffect(() => {
    if (render) return setRender(false);
    dispatch(getUsers({ new: true }));
  }, [render, dispatch]);

  return (
    <>
      <h1 className="users__title">Нові користувачі</h1>
      <ul className="users__list">
        {usersList?.map((i, idx) => {
          const { user_id, name, phone } = i ?? {};
          return (
            <li className="users__item user" key={user_id || idx}>
              <div className='user__name-wrap'>
                <span className="user__number">{idx + 1}</span>
                <span className="user__name">{name}</span>
                <span className="user__phone">{phone}</span>
              </div>
              <div className="user__btn-wrap">
                <button className="user__btn--confirm" type="button" onClick={() => onUpdate(user_id, 'confirm')} > Прийняти </button>
                <button className="user__btn--reject" type="button" onClick={() => onUpdate(user_id, 'reject')} > Відхилити </button>
              </div>
            </li>
          );
        })}
      </ul>
    </>
  );
};

export default NewUsersList;
